module.exports = __webpack_public_path__ + "img/qx60-2025.16733d08.png";